<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../assets/css/common.css";

body {
    background: green;
}

main {
    position: absolute;
    height: 100%;
    width: 100%;
    text-align: center;
    overflow: hidden;
}

.wrap {
    height: 100%;
    max-width: 750px;
    margin: 0 auto;
    position: relative;
}

.activity-bg {
    display: inline-block;
    max-width: 100%;
    height: 100%;
    position: relative;
}

.activity-bg img {
    width: 100%;
    max-width: 750px;
    max-height: 120%;
}

.content-topbox {
    position: absolute;
    width: 90%;
    top: 0;
    height: 200px;
    background: none;
    left: 5%;
}

.content-logimg {
    width: 60%;
    margin: 2% 0;
}

.content-shareimg {
    width: 20%;
    position: absolute;
    right: 0px;
    top: 0px;
}

.content-bottbox {
    position: absolute;
    width: 100%;
    height: 66%;
    background: none;
    bottom: 0;
    left: 0;
    z-index: 1;
    /*background: url(../assets/img/envelope/rdnew@3x.png) no-repeat;*/
    background-size: 100% 100%;
    transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    /* IE 9 */
    -moz-transform: rotate(0deg);
    /* Firefox */
    -webkit-transform: rotate(0deg);
    /* Safari 和 Chrome */
    -o-transform: rotate(0deg);
    /* Opera */
}

.content-bottbox>img {
    width: 100%;
}

.content-box form {
    padding: 0 20px;
}

.content-box fieldset {
    border: none;
    padding: 0;
}

.content-box label {
    display: block;
    line-height: 30px;
    font-size: 14px;
    color: #60D8C4;
    padding: 15px 0 10px;
}

.content-box input {
    width: 100%;
    height: 44px;
    line-height: 44px;
    font-size: 14px;
    border: none;
    background: #EAF8F6;
    border-radius: 5px;
    text-indent: 1em;
}

.content-price h1 {
    font-size: 36px;
    font-weight: 900;
}

.content-price>h1>span {
    font-size: 16px;
}

.content-price p {
    font-size: 16px;
}

.content-button {
    width: 80%;
    height: 70px;
    line-height: 70px;
    margin: 0 auto;
    color: rgb(162, 134, 60);
    font-size: 18px;
    font-weight: 900;
}

.content-introduce {
    font-size: 16px;
    color: rgb(255, 255, 255);
    text-decoration: underline;
}

.envelope-prompt {
    margin-bottom: 10px;
}

.envelope-prompt p {
    font-family: MicrosoftYaHei-Bold;
    font-size: 36px;
    color: #F7DD28;
    letter-spacing: 0;
    text-shadow: 0 2px 4px rgba(130, 130, 130, 0.50);
}

.envelope-prompt span {
    font-family: MicrosoftYaHei;
    font-size: 16px;
    color: #FFFFFF;
    text-shadow: 0 2px 4px rgba(130, 130, 130, 0.50);
}

.list-css {
    position: absolute;
    bottom: 27%;
    width: 81%;
    overflow: auto;
    border-radius: 10px;
    padding: 10px;
    margin-left: 9.5%;
    overflow-y: scroll;
}

.bac-css {
    max-height: 72%;
    min-height: 150px;
    background: rgb(246, 246, 246);
    z-index: 0;
    border-bottom-left-radius: 170px 65px;
    border-bottom-right-radius: 170px 65px;
    -webkit-border-bottom-left-radius: 170px 65px;
    -webkit-border-bottom-right-radius: 170px 65px;
    -o-border-bottom-left-radius: 170px 65px;
    -o-border-bottom-right-radius: 170px 65px;
    -ms-border-bottom-left-radius: 170px 65px;
    -ms-border-bottom-right-radius: 170px 65px;
    -moz-border-bottom-left-radius: 170px 65px;
    -moz-border-bottom-right-radius: 170px 65px;
    -webkit-mask-image: linear-gradient(to bottom, rgb(0, 0, 0), rgb(0, 0, 0));
}

.newbac-css {
    height: 74%;
    background: rgba(0, 0, 0, 0.4);
}

.list-css li {
    height: 86px;
    line-height: 86px;
    font-size: 20px;
    color: rgb(255, 255, 255);
    padding-right: 6%;
    margin-bottom: 6px;
    /*color: rgb(247, 221, 40);*/
}

.price {
    font-family: MicrosoftYaHei-Bold;
    font-size: 20px;
    height: 100%;
    width: 33%;
    text-align: center;
    overflow: hidden;
}

.price .span-css {
    font-size: 16px;
    margin-left: 6px;
}

.toast-body {
    display: block;
    top: 20%;
    padding-bottom: 20px;
    width: 80%;
    left: 10%;
}

.toast-title {
    color: rgb(102, 102, 102);
    border-bottom: 1px solid rgb(221, 221, 221);
    margin: 0px auto;
    display: inline-block;
    padding: 6px 0px;
    height: 50px;
    line-height: 50px;
    font-size: 18px;
}

.toast-msg {
    text-align: left;
    max-height: 290px;
    padding-bottom: 0px;
}

.bacbottom-img {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 28%;
}

.content-img {
    background-size: 100% 100%;
}

.count {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #A6A6A6;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.content-fr {
    line-height: 30px;
    padding: 12px 0;
    text-align: right;
    width: 66%;
    overflow: hidden;
}

.dow-title {
    display: block;
    width: 80%;
    background: url(http://atour-wechat.qiniu.yaduo.com/hongbao-Botton@2x.png) no-repeat;
    background-size: contain;
    background-position: center center;
    height: 60px;
    margin: 15px auto;
}

.envelope-prompt .size-color {
    font-size: 20px;
    color: rgb(228, 193, 147);
}

.content-img {
    background-size: 100% 100%;
}
</style>
<template>
    <main>
        <div class="wrap" v-if="configType">
            <section class="activity-bg">
                <img :src="configData.backgroundImage">
                <div class="content-topbox">
                    <share :title="configData.subTitle" :desc="configData.shareUrlTitle" :imgUrl="configData.shareUrlImage" :link="link">
                    </share>
                    <img :src="configData.logoImage" class="content-logimg" v-if="configData.sort!=3">
                    <img :src="configData.successSubTitle" class="content-logimg" v-if="configData.sort==3">
                    <div class="envelope-prompt" v-if="configData.sort!=3">
                        <p>{{isLogin ? "已成功领取" : "领取成功"}}</p>
                        <span>优惠券已放入{{upPhoneNum(phone)}}的会员账户</span>
                    </div>
                    <div class="envelope-prompt" v-if="configData.sort==3">
                        <p class="size-color">恭喜您
                            <br/>成为亚朵金卡会员</p>
                        <span>专属百元礼包已放入您的亚朵账户</span>
                    </div>
                </div>
                <div class="content-bottbox" :style="configData.marketValue==1?'':(configData.envelopeImage ? ('background: url(' + configData.envelopeImage + ') no-repeat;background-size: 100% 100%;') : '')">
                    <ul class="list-css" tabindex='-1' :class="configData.marketValue==1?'newbac-css':'bac-css'" :style="configData.sort==3?'bottom: 16%;':''">
                        <li class="clearfix content-img" v-for="item in couponList" :style="configData.successSubTitle?('background: url('+configData.successSubTitle+') no-repeat;background-size: 100% 100%;'):''">
                            <div class="fl price clearfix" :style="configData.successTitle?('background: url('+configData.successTitle+') no-repeat;background-size: 100% 100%;'):''">
                                <p class="">{{item.value}}元</p>
                            </div>
                            <div class="fr content-fr">
                                <p class="count">{{item.disTypeName}}</p>
                                <p class="count" style="color: #FB3653;">x{{item.count ? item.count : 1}}</p>
                            </div>
                        </li>
                    </ul>
                    <div class="bacbottom-img">
                        <p class="content-button" v-if="configData.marketValue!=1" @click="goWechat()" :style="configData.buttonImage?('background: url('+configData.buttonImage+') no-repeat;background-size: 100% 100%;'):''">
                            立即使用</p>
                        <a class="dow-title" @click="useAction"></a>
                    </div>
                </div>
            </section>
        </div>
    </main>
</template>
<script>
import components from '../components'

export default {
    name: 'treatmentList',
    data() {
        return {
            isShow: false,
            isLogin: false,
            configType: false, //是否
            userMarketFlag: true, //是否
            phoneNum: true, //是否
            phone: '',
            link: "",
            ActivityUserData: {},
            couponList: {},
            configData: {},
        }
    },
    methods: {
        upImg() {
            let imgUrl = ''
            if (this.configData.marketValue != 1) {
                imgUrl = this.configData.envelopeImage ? ('background: url(' + this.configData.envelopeImage + ') no-repeat;background-size: 100% 100%;') : ''
            }
            return imgUrl
        },
        goWechat() {
            window.location.href = HTTPS;
        },
        listTemp: function(list) {
            let map = {},
                dest = [];
            for (let i = 0; i < list.length; i++) {
                let ai = list[i];
                if (!map[ai.value]) {
                    dest.push({
                        disTypeName: ai.disTypeName,
                        value: ai.value,
                        count: 1
                    });
                    map[ai.value] = ai;
                } else {
                    for (var j = 0; j < dest.length; j++) {
                        var dj = dest[j];
                        if (dj.value == ai.value) {
                            ++dest[j].count;
                            break;
                        }
                    }
                }
            }
            return dest
        },
        showToast(type) {
            this.isShow = type;
            if (type)
                _czc.push(['_trackEvent', ('列表活动-' + this.marketId), '点击查看规则', "点击查看规则", '1', 'playBtn']);
        },
        getCoupon() {
            //获取优惠券列表
            var data = { phoneNum: this.phone, marketId: this.marketId }
            if (this.phone) {
                site._post(JAVA_SERVER + '/atourlife/coupon/getCouponsListByMarketIdNotToken', data, this, function(result) {
                    if (result.retcode == 0) {
                        if (this.configData.marketValue == 1) {
                            this.couponList = result.result
                        } else {
                            this.couponList = this.listTemp(result.result)
                        }
                    } else {
                        toast.showToast(result.retmsg);
                    }
                })
            }
        },
        inspectType(data) {
            if (!data || typeof(data) == "undefined" || typeof(data) == "string")
                return false;
            return true;
        },
        getMarketConfig() {
            //活动首页显示基础配置表接口
            var data = { marketId: this.marketId }
            site._post(JAVA_SERVER + '/atourlife/marketConfig/getMarketConfig', data, this, function(result) {
                if (result.retcode == 0) {
                    this.configData = result.result;
                    this.configType = true;
                    this.getCoupon();
                } else {
                    toast.showToast(result.retmsg);
                }
            })
        },
        upPhoneNum(tel) {
            if (tel) {
                var mtel = tel.substr(0, 3) + '****' + tel.substr(7);
                return mtel
            }
        },
        useAction() {
            if (Prius && Prius.isInsideApp) {
                Prius.backpage({})
            } else {
                window.location.href ='http://wechat.yaduo.com'
            }
        }
    },
    components: components,
    mounted() {
        this.marketId = this.$route.params.marketId;
        this.phone = localStorage.getItem('mobile')
        this.link = location.origin + location.pathname + "#/home/" + this.marketId + "?utm_medium=" + this.marketId + '&activitySource=' + localStorage.getItem('activitySource') + '&activeId=' + localStorage.getItem('activeId');
        if (!this.inspectType(this.ActivityUserData)) {
            this.$router.push({
                path: '/home/' + this.marketId,
                query: {
                    activitySource: localStorage.getItem('activitySource'),
                    activeId: localStorage.getItem('activeId')
                }
            });
            return false;
        }
        if (localStorage.getItem('marketId')!=this.marketId) {
            this.$router.push({
                path: '/home/' + this.marketId,
                query: {
                    activitySource: localStorage.getItem('activitySource'),
                    activeId: localStorage.getItem('activeId')
                }
            });
        }
        this.$nextTick(function() {
            this.getMarketConfig()
        })
    },
}
</script>



// WEBPACK FOOTER //
// treatmentList.vue?7e3512f1